/* tslint:disable */
/* eslint-disable */
/**
 * Control Online API
 * Control Online API
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from "../runtime";
/**
 *
 * @export
 * @interface AdminCourseDto
 */
export interface AdminCourseDto {
  /**
   *
   * @type {string}
   * @memberof AdminCourseDto
   */
  id: string;
  /**
   *
   * @type {string}
   * @memberof AdminCourseDto
   */
  name: string;
  /**
   *
   * @type {Date}
   * @memberof AdminCourseDto
   */
  createdAt: Date;
}

export function AdminCourseDtoFromJSON(json: any): AdminCourseDto {
  return AdminCourseDtoFromJSONTyped(json, false);
}

export function AdminCourseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): AdminCourseDto {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    id: json["id"],
    name: json["name"],
    createdAt: new Date(json["createdAt"]),
  };
}

export function AdminCourseDtoToJSON(value?: AdminCourseDto | null): any {
  if (value === undefined) {
    return undefined;
  }
  if (value === null) {
    return null;
  }
  return {
    id: value.id,
    name: value.name,
    createdAt: value.createdAt.toISOString(),
  };
}
